import Header from './Header.styled';

export default Header;
